import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import Table from 'react-bootstrap/Table';
import ItemResDef from './ItemResDef';
import authService from '../../services/AuthService';
import api, { apiErrorHandler } from '../../services/AxiosService';
import { apiErrorPopup } from '../../helpers/MessagePopup';

class ItemResDefs extends Component {

    constructor(props) {
        super(props);

        this.state = {
            domain: props.domain,
            resItems: null
        }

        this.itemResDefs = [];
    }

    itemResChangeHandler = (itemDefId, pic, audio, video, doc, url) => {
        let found = false;
        for (let i = 0; i < this.itemResDefs.length; i++) {
            if (this.itemResDefs[i].itemDefId == itemDefId) {
                // Found it.  Update the item
                found = true;

                // Null values mean that items was NOT changed during this call and should not be updated
                if (pic != null) {
                    this.itemResDefs[i].picFilename = pic;
                }
                if (audio != null) {
                    this.itemResDefs[i].audioFilename = audio;
                }
                if (video != null) {
                    this.itemResDefs[i].videoFilename = video;
                }
                if (doc != null) {
                    this.itemResDefs[i].docFilename = doc;
                }
                if (url != null) {
                    this.itemResDefs[i].url = url;
                }
                break;
            }
        }

        if (!found) {
            this.itemResDefs.push({ itemDefId: itemDefId, picFilename: pic, audioFilename: audio, videoFilename: video, docFilename: doc, url: url });
        }
        this.props.itemResourceChangeHandler(this.itemResDefs);
    }

    componentDidMount = () => {
        /*
         * Run a query to get the information for the domain specified in props (null is all domains).
         * The query returns a list of definitions. 
         */
        let domainName = (this.state.domain == null || this.state.domain == "") ? "All" : this.state.domain;

        let url = "admin/" + domainName + "/itemresources";
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })  
            .then((response) => {
                if (response.status == 200) {
                this.setState({
                    resItems: response.data.resources
                });
            }
        })
        .catch(error => {
            // Major problem - should not happen.  Back to login?
            apiErrorPopup(apiErrorHandler(error));
        });
    }

    render() {
        // Build the table's rows.  
        let resItems = null;
        if (this.state.resItems != null) {
            resItems = this.state.resItems.map((item) => {
                return (
                    <ItemResDef
                        itemDefId={item.itemDefId}
                        domainName={item.domainName}
                        assessmentArea={item.assessmentArea}
                        picFilename={item.picFilename}
                        audioFilename={item.audioFilename}
                        videoFilename={item.videoFilename}
                        docFilename={item.docFilename}
                        url={item.url}
                        changeHandler={this.itemResChangeHandler}
                    />
                );
            })
        }
        return (
            <Form>
                <br/>
                <p>Use this area is to input associations.  To input CadeResources (title, description, etc.), use MySQL Workbench</p>
                <Table striped bordered responsive size="sm">
                    <thead>
                        <tr>
                            <th>Domain</th>
                            <th>Assessment Area</th>
                            <th>Picture Filename</th>
                            <th>Audio Filename</th>
                            <th>Video Filename</th>
                            <th>Document Filename</th>
                            <th>Web Url</th>
                        </tr>
                    </thead>
                    <tbody>
                        {resItems}
                    </tbody>
                </Table>
            </Form>
        );
    }
}

export default ItemResDefs;


// WEBPACK FOOTER //
// ./src/components/AdminHome/ItemResDefs.js